import { render, staticRenderFns } from "./CustomerLogsPart.vue?vue&type=template&id=6e78f77a&scoped=true"
import script from "./CustomerLogsPart.vue?vue&type=script&lang=ts"
export * from "./CustomerLogsPart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e78f77a",
  null
  
)

export default component.exports